import { render, staticRenderFns } from "./measures.vue?vue&type=template&id=2d24decc"
import script from "./measures.vue?vue&type=script&lang=js"
export * from "./measures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports